(function () {
  theme.Currency = (function () {
    var moneyFormat = theme.moneyFormat;

    function formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";
        if (isNaN(number) || number === null) {
          return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }
    return {
      formatMoney: formatMoney,
    };
  })();

  function productPages() {
    if (!location.href.includes("/products")) return;
    const variantJson = JSON.parse(
      document.querySelector(".product-variant-json").innerHTML
    );
    const optionSelectorWrapper = document.querySelector("#product-box");
    const colorOptions = optionSelectorWrapper.querySelectorAll(
      '.color-select input[type="radio"]'
    );
    const singleDropdown = optionSelectorWrapper.querySelectorAll(
      "#singleDropdown .dropdown__item[data-id]"
    );
    const multipleDropdown = optionSelectorWrapper.querySelectorAll(
      ".option__selector_select"
    );
    const normalSelectOption = optionSelectorWrapper.querySelectorAll(
      ".normal__select_option"
    );
    const quantityPlus =
      optionSelectorWrapper.querySelectorAll(".counter__btn_plus");
    const quantityMin = optionSelectorWrapper.querySelectorAll(
      ".counter__btn_minus"
    );
    const quantity = document.querySelector("#quantity");
    const soldOut = document.querySelector("#out-of-stock");
    const masterSelector = document.querySelector(".product-single__variants");
    const form = document.querySelector("#form-add-to-cart");
    const regularPrice = document.querySelector("#regular-price");
    const addToCart = document.querySelector("#addToCart span");
    const prodTitle = document.querySelector(".prod__title");
    const prodSelectedColor = document.querySelector(".prod__selected_color");

    function buildOptionArray(option) {
      let array = [];
      if (option.checked) {
        array.push(option.getAttribute("data-option-value"));
      }
      return array;
    }

    function outOfStock() {
      addToCart.setAttribute("disabled", "disabled");
      addToCart.innerHTML = "Out of stock";
    }

    function inStock() {
      addToCart.removeAttribute("disabled");
      addToCart.innerHTML = "Add to cart";
      soldOut.style.display = "none";
    }

    function notAvailable() {
      addToCart.setAttribute("disabled", "disabled");
      addToCart.innerHTML = "Not Available";
    }

    function getSelectedVariant(id) {
      Array.from(masterSelector).forEach(function (selector) {
        if (!selector.hasAttribute("value")) return;
        selector.removeAttribute("selected");
        id === parseInt(selector.value) &&
          selector.setAttribute("selected", "selected");
      });
    }

    function updatePrices(price) {
      regularPrice.innerHTML = theme.Currency.formatMoney(
        price,
        theme.moneyFormat
      );
    }
    function showSelectedColor(options) {
      prodTitle.innerHTML = `Selected Colour: <strong>${options[0]}</strong>`;
    }
    function initVariantChange(selectedOptions) {
      const o = JSON.stringify(selectedOptions.sort());
      for (let variant in variantJson) {
        if (JSON.stringify(variantJson[variant].options.sort()) === o) {
          if (!variantJson[variant].available) {
            outOfStock();
            updatePrices(variantJson[variant].price);
          } else {
            inStock();
            getSelectedVariant(variantJson[variant].id);
            updatePrices(variantJson[variant].price);
          }
          break;
        } else {
          notAvailable();
        }
      }
    }

    function meterCalculator() {
      const meterInput = document.querySelector("#input-meter");
      const calculate = document.getElementById("calculate");
      const multipleValue = parseFloat(
        JSON.parse(document.querySelector("#m2").innerHTML)
      );
      calculate.addEventListener("click", function (e) {
        e.stopPropagation();
        const meters = meterInput.value;
        quantity.value = parseInt(meters * multipleValue);
      });
    }

    function quantityHandler() {
      quantityPlus.forEach(function (plus) {
        plus.addEventListener("click", function (e) {
          e.stopPropagation();
          quantity.value = parseInt(quantity.value) + 1;
        });
      });
      quantityMin.forEach(function (minus) {
        minus.addEventListener("click", function (e) {
          e.stopPropagation();
          if (quantity.value >= "1") {
            quantity.value = parseInt(quantity.value) - 1;
          }
        });
      });
    }

    function colorSwatches() {
      if (typeof colorOptions === "undefined" || theme.template !== "product")
        return;
      colorOptions.forEach(function (option) {
        if (option.checked) {
          const selectedOptions = buildOptionArray(option);
          showSelectedColor(selectedOptions);
          initVariantChange(selectedOptions);
        }
      });

      function optionSelector() {
        colorOptions.forEach(function (option) {
          option.addEventListener("change", function (e) {
            const target = e.target;
            const selectedOptions = buildOptionArray(target);
            showSelectedColor(selectedOptions);
            initVariantChange(selectedOptions);
          });
        });
      }
      optionSelector();
    }

    function singleDropdownSelector() {
      function trackStocks(id) {
        variantJson.map(function (variant) {
          if (id === variant.id) {
            if (!variant.available) {
              outOfStock();
              updatePrices(variant.price);
              return;
            } else {
              inStock();
              getSelectedVariant(variant.id);
              updatePrices(variant.price);
            }
          }
        });
      }
      if (singleDropdown.length === 0) return;
      const id = singleDropdown[0].getAttribute("data-id");
      trackStocks(parseInt(id));

      function handleClick() {
        singleDropdown.forEach(function (downdrop) {
          downdrop.addEventListener("click", function (e) {
            const target = e.target;
            const id = target
              .closest(".dropdown__item[data-id]")
              .getAttribute("data-id");
            trackStocks(parseInt(id));
          });
        });
      }
      handleClick();
    }

    function multipleDropdownHandler() {
      if (theme.template !== "product.variant-combination") return;
      let array = [];

      const dropdown = document.querySelectorAll(
        "#dropdown-selector .dropdown__item"
      );
      dropdown.forEach(function (item) {
        if (item.getAttribute("data-selected") === "true")
          array.push(item.getAttribute("data-option-value"));
      });
      colorOptions.forEach(function (option) {
        if (option.checked)
          array.push(option.getAttribute("data-option-value"));
      });
      initVariantChange(array);

      function handleMultipleOptions() {
        colorOptions.forEach(function (option) {
          option.addEventListener("change", function (e) {
            e.stopPropagation();
            let selectedOptions = [];
            const target = e.target;
            selectedOptions.push(target.getAttribute("data-option-value"));
            dropdown.forEach(function (item) {
              if (item.getAttribute("data-selected") === "true")
                selectedOptions.push(item.getAttribute("data-option-value"));
            });
            showSelectedColor(selectedOptions);
            initVariantChange(selectedOptions);
          });
        });
        dropdown.forEach(function (item) {
          item.addEventListener("click", function (e) {
            e.stopPropagation();
            let array = [];
            const target = e.target;
            const value = target
              .closest(".dropdown__item")
              .getAttribute("data-option-value");
            dropdown.forEach(function (item) {
              item.setAttribute("data-selected", "false");
            });
            target
              .closest(".dropdown__item")
              .setAttribute("data-selected", "true");
            array.push(value);
            colorOptions.forEach(function (option) {
              if (option.checked)
                array.push(option.getAttribute("data-option-value"));
            });
            initVariantChange(array);
          });
        });
      }
      handleMultipleOptions();
    }

    function selectOptionhandler() {
      if (theme.template != "product.dropdown-selector") return;
      let selectedOptions = [];
      normalSelectOption.forEach(function (option) {
        selectedOptions.push(option.selectedOptions[0].value);
      });
      initVariantChange(selectedOptions);

      function selectedOptionsChangehandler() {
        normalSelectOption.forEach(function (option) {
          option.addEventListener("change", function (e) {
            let array = [];
            normalSelectOption.forEach(function (option) {
              array.push(option.selectedOptions[0].value);
            });
            initVariantChange(array);
          });
        });
      }
      selectedOptionsChangehandler();
    }

    function productCombinationTow() {
      if (theme.template != "product.combination-2") return;
      colorOptions.forEach(function (option) {
        if (option.checked) {
          const selectedOptions = buildOptionArray(option);
          showSelectedColor(selectedOptions);
          initVariantChange(selectedOptions);
        }
      });

      function optionSelector() {
        colorOptions.forEach(function (option) {
          option.addEventListener("change", function (e) {
            const target = e.target;
            const selectedOptions = buildOptionArray(target);
            showSelectedColor(selectedOptions);
            initVariantChange(selectedOptions);
          });
        });
      }
      optionSelector();
      meterCalculator();
      quantityHandler();
    }

    function m2Calculator() {
      if (theme.template != "product.m2-calculator") {
        return;
      }

      meterCalculator();
      quantityHandler();
    }

    function productMultipleChoice() {
      if (theme.template != "product.multiple-choice") return;
      const sizeSelectors = optionSelectorWrapper.querySelectorAll(
        ".size[data-variant-id]"
      );
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        let items = [];
        let singleItem = {
          id: "",
          quantity: "",
        };
        sizeSelectors.forEach(function (option) {
          if (option.querySelector(".quanity_input").value !== "0") {
            singleItem = {
              id: parseInt(option.getAttribute("data-variant-id")),
              quantity: parseInt(option.querySelector(".quanity_input").value),
            };
            items.push(singleItem);
          }
        });

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: items,
          }),
        })
          .then((response) => {
            if (response.ok) {
              location.assign("/cart");
            } else if (!response.ok) {
              document.querySelector("#error").style.display = "block";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    }

    function productComplex() {
      if (theme.template != "product.multiple-choice-m2-calculations") return;
      const calculateBtn = document.querySelectorAll(".calculate__quantity");
      const value1 = JSON.parse(document.querySelector("#m2-1").innerHTML);
      const value2 = JSON.parse(document.querySelector("#m2-2").innerHTML);
      const value3 = JSON.parse(document.querySelector("#m2-3").innerHTML);
      const minus = document.querySelectorAll(".counter__btn_minus");
      const plus = document.querySelectorAll(".counter__btn_plus");
      minus.forEach(function (minus) {
        minus.addEventListener("click", function (e) {
          const target = e.target;
          const parent = target.closest(".counter");
          const quantity = parent.querySelector(".counter__number_quantity");
          const value = parseInt(quantity.value);
          if (value === 1) return;
          quantity.value = value - 1;
        });
      });
      plus.forEach(function (plus) {
        plus.addEventListener("click", function (e) {
          const target = e.target;
          const parent = target.closest(".counter");
          const quantity = parent.querySelector(".counter__number_quantity");
          const value = parseInt(quantity.value);
          quantity.value = value + 1;
        });
      });
      const submitButton = document.querySelectorAll(".variant__add-to-cart");
      calculateBtn.forEach(function (btn) {
        
        cosole.log("btn=" + btn);
        btn.addEventListener("click", function (e) {
          e.stopPropagation();
          const target = e.target;
          const wrapper = target.closest(".prod__line[data-variant-id]");
          const line = wrapper.getAttribute("data-line");
          if (line === "1") {
            const lineMeters = wrapper.querySelector(".input__meter").value;
            const resultInput = wrapper.querySelector(
              ".counter__number_quantity"
            );
            resultInput.value = parseInt(parseInt(lineMeters) * value1);
          }
          if (line === "2") {
            const lineMeters = wrapper.querySelector(".input__meter").value;
            const resultInput = wrapper.querySelector(
              ".counter__number_quantity"
            );
            resultInput.value = parseInt(parseInt(lineMeters) * value2);
          }
          if (line === "3") {
            const lineMeters = wrapper.querySelector(".input__meter").value;
            const resultInput = wrapper.querySelector(
              ".counter__number_quantity"
            );
            resultInput.value = parseInt(parseInt(lineMeters) * value3);
          }
        });
      });
      submitButton.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const target = e.target;
          const wrapper = target.closest(".prod__line[data-variant-id]");
          const id = parseInt(wrapper.getAttribute("data-variant-id"));

          const variantQuantity = parseInt(
            wrapper.querySelector(".counter__number_quantity").value
          );

          const items = {
            items: [
              {
                id: id,
                quantity: variantQuantity,
              },
            ],
          };

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(items),
          })
            .then((response) => {
              if (response.ok) {
                location.assign("/cart");
              } else {
                return response.json();
              }
            })
            .then((data) => {
              wrapper.querySelector(".error__item").innerHTML =
                data.description;
              wrapper.querySelector(".error__item").style.display = "block";
            })
            .catch((error) => console.log(error));
        });
      });
    }
    colorSwatches();
    singleDropdownSelector();
    multipleDropdownHandler();
    selectOptionhandler();
    productCombinationTow();
    m2Calculator();
    productMultipleChoice();
    productComplex();
  }

  function collectionAllPage() {
    if (!location.href.includes("/collections/all")) return;
    const searchForm = document.querySelector("#search");
    const productsWrapper = document.querySelector("#products-grid");
    searchForm.addEventListener("submit", function (e) {
      e.preventDefault();
      const value = searchForm.querySelector(".search__input").value;
      const url = `/search/suggest.json?q=${value}&resources[type]=product&resources[options][unavailable_products]=last`;
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          productsWrapper.innerHTML = "";
          const products = data.resources.results.products;
          if (products.length > 0) {
            products.map(function (product) {
              renderProduct(product);
            });
          } else {
            noResults();
          }
        });
    });

    function renderProduct(product) {
      const markup = `
            <div class="product">
                <a href="${product.url}" class="product__link"></a>
                <div class="product__top">
                <div class="product__figure">
                    <img class="product__img" src="${product.image}"> 
                </div>
                <div class="product__title">${product.title}</div>
                </div>
                <div class="product__bottom">
                <div class="product__spec">60x79x110 cm</div>
                <div class="product__price">${theme.Currency.formatMoney(
                  product.price,
                  theme.moneyFormat
                )}</div>
                </div>
            </div>
            `;
      const grid = document.createElement("div");
      grid.classList.add("p-grid__cell");
      grid.innerHTML = markup;
      productsWrapper.appendChild(grid);
    }

    function noResults() {
      const markup = `
            <div class="lead">
                <h1 class="lead__note">
                No Results
                </h1>
                <p></p>
                <a href="${location.href}" class="btn">Refresh Page</a>
            </div>
            `;
      const grid = document.createElement("div");
      grid.classList.add("frame", "mb-0");
      grid.style.width = "100%";
      grid.innerHTML = markup;
      productsWrapper.appendChild(grid);
    }
  }

  function collectionPages() {
    if (location.href.includes("/collections/all")) {
      const searchForm = document.querySelector("#search");
      const productsWrapper = document.querySelector("#products-grid");
      if (searchForm === null) return;
      searchForm.addEventListener("submit", function (e) {
        e.preventDefault();
        const value = searchForm.querySelector(".search__input").value;
        const url = `/search/suggest.json?q=${value}&resources[type]=product&resources[options][unavailable_products]=last`;
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            productsWrapper.innerHTML = "";
            const products = data.resources.results.products;
            if (products.length > 0) {
              products.map(function (product) {
                renderProduct(product);
              });
            } else {
              noResults();
            }
          });
      });

      function renderProduct(product) {
        const markup = `
                <div class="product">
                    <a href="${product.url}" class="product__link"></a>
                    <div class="product__top">
                    <div class="product__figure">
                        <img class="product__img" src="${product.image}">
                        <!-- <div class="product__add" title="Add to Cart" data-id="39723534975129" data-added-to-cart="false"></div> --> 
                    </div>
                    <div class="product__title">${product.title}</div>
                    </div>
                    <div class="product__bottom">
                    <div class="product__spec">60x79x110 cm</div>
                    <div class="product__price">${theme.Currency.formatMoney(
                      product.price,
                      theme.moneyFormat
                    )}</div>
                    </div>
                </div>
                `;
        const grid = document.createElement("div");
        grid.classList.add("p-grid__cell");
        grid.innerHTML = markup;
        productsWrapper.appendChild(grid);
      }

      function noResults() {
        const markup = `
                <div class="lead">
                    <h1 class="lead__note">
                    No Results
                    </h1>
                    <p></p>
                    <a href="${location.href}" class="btn">Refresh Page</a>
                </div>
                `;
        const grid = document.createElement("div");
        grid.classList.add("frame", "mb-0");
        grid.style.width = "100%";
        grid.innerHTML = markup;
        productsWrapper.appendChild(grid);
      }
    }
  }
  productPages();
  collectionAllPage();
  collectionPages();
})();
